import type { AuthResponse, User } from '@conversia/shared-types';
import { api } from './client';

/** Endpoints de autenticación. Prefijo: /api/auth */

export interface RegisterInput {
  email: string;
  password: string;
  name?: string;
}

export const login = (input: { email: string; password: string }) =>
  api.post<AuthResponse>('/api/auth/login', input, { skipAuth: true });

export const register = (input: RegisterInput) =>
  api.post<AuthResponse>('/api/auth/register', input, { skipAuth: true });

export const refresh = (refreshToken: string) =>
  api.post<AuthResponse>('/api/auth/refresh', { refreshToken }, { skipAuth: true });

export const logout = (refreshToken: string) =>
  api.post<{ success: boolean }>('/api/auth/logout', { refreshToken }, { skipAuth: true });

export const me = () => api.get<User>('/api/auth/me');

/** Canjea una invitación: crea la cuenta del invitado con su contraseña. */
export const acceptInvitation = (input: { token: string; password: string; name?: string }) =>
  api.post<User>('/api/auth/accept-invitation', input, { skipAuth: true });

/** "Olvidé mi contraseña": respuesta idéntica exista o no la cuenta. */
export const forgotPassword = (email: string) =>
  api.post<{ message: string }>('/api/auth/forgot-password', { email }, { skipAuth: true });

/** Canjea el token de reset y fija la clave nueva. */
export const resetPassword = (input: { token: string; password: string }) =>
  api.post<{ success: boolean }>('/api/auth/reset-password', input, { skipAuth: true });

/** Cambiar la clave PROPIA con la sesión abierta (pide la actual). */
export const changeMyPassword = (input: { currentPassword: string; newPassword: string }) =>
  api.post<{ success: boolean }>('/api/me/password', input);
